export default __webpack_public_path__ + "static/media/vpTransit.b04e20df.svg";